import Token from '@/utils/Token';

function jsonHeaders() {
    return {
        headers: {
            ...Token.getHeader().headers,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };
}

export default {
    geminiStatus() {
        return axios.get('/api/sistema/configuracao/gemini', Token.getHeader());
    },

    geminiUpdate(params) {
        return axios.put('/api/sistema/configuracao/gemini', params, jsonHeaders());
    },

    iaIntegracoesList() {
        return axios.get('/api/sistema/ia-integracoes', Token.getHeader());
    },

    iaIntegracaoStore(payload) {
        return axios.post('/api/sistema/ia-integracoes', payload, jsonHeaders());
    },

    iaIntegracaoUpdate(id, payload) {
        return axios.put(`/api/sistema/ia-integracoes/${id}`, payload, jsonHeaders());
    },

    iaIntegracaoDestroy(id) {
        return axios.delete(`/api/sistema/ia-integracoes/${id}`, Token.getHeader());
    },

    getDadosBancarios() {
        return axios.get('/api/sistema/configuracao/dados-bancarios', Token.getHeader());
    },

    updateDadosBancarios(payload) {
        return axios.put('/api/sistema/configuracao/dados-bancarios', payload, jsonHeaders());
    },

    getDadosBancariosStatus() {
        return axios.get('/api/sistema/configuracao/dados-bancarios/status', Token.getHeader());
    },
};

export function getDadosBancarios() {
    return axios.get('/api/sistema/configuracao/dados-bancarios', Token.getHeader());
}

export function updateDadosBancarios(payload) {
    return axios.put('/api/sistema/configuracao/dados-bancarios', payload, jsonHeaders());
}

export function getDadosBancariosStatus() {
    return axios.get('/api/sistema/configuracao/dados-bancarios/status', Token.getHeader());
}
